/**
 * İzin kaynağı yapılandırması.
 *
 * Mod 1 (login)  : JWT/login permissions[] — düz key listesi (read=write)
 * Mod 2 (grants) : GET /api/Identity/UserPermissions — read/write grant listesi
 *
 * Grants API açıkken önce API kullanılır; yüklenemezse login permissions[] fallback.
 */
export type PermissionSourceMode = 'login' | 'grants';

/** Backend UserPermissions endpoint'i hazır — true */
export const USER_PERMISSIONS_GRANTS_API_ENABLED = true;

export const PERMISSION_SOURCE_MODE: PermissionSourceMode =
  USER_PERMISSIONS_GRANTS_API_ENABLED ? 'grants' : 'login';
